import { JackpotTierName } from '../enums';
import { T } from './translation-keys';

import ClubSymbol from '../assets/media/jackpot/club-single.png';
import DiamondSymbol from '../assets/media/jackpot/diamond-single.png';
import HeartSymbol from '../assets/media/jackpot/hearts-single.png';
import SpadeSymbol from '../assets/media/jackpot/spade-single.png';

export const JackpotSymbolNames = {
  [JackpotTierName.Club]: T.CLUB,
  [JackpotTierName.Diamond]: T.DIAMOND,
  [JackpotTierName.Heart]: T.HEART,
  [JackpotTierName.Spade]: T.SPADE
};

export const JackpotSymbolImages = {
  [JackpotTierName.Club]: ClubSymbol,
  [JackpotTierName.Diamond]: DiamondSymbol,
  [JackpotTierName.Heart]: HeartSymbol,
  [JackpotTierName.Spade]: SpadeSymbol
};
